module.exports = __webpack_public_path__ + "img/pro_pic.dae1ceb0.png";